export const customerKeys = {
  'Szerződés száma': '',
  'Cég megnevezése': '',
  'Cég címe': '',
  'Cég adószáma': '',
  'Cégjegyzékszám': '',
  'Bankszámlaszáma': '',

  'Képviselő neve': '',
  'Kapcsolattartó neve': '',
  'Kapcsolattartó e-mail': '',
  'Kapcsolattartó telefon': '',
  'Kapcsolattartó fax': '',

  'Pénzügyi kapcsolattartó neve': '',
  'Pénzügyi kapcsolattartó e-mail': '',
  'Pénzügyi kapcsolattartó telefon': '',
  'További számlázási e-mail címek': '',
  'Dátum': '',

  'Fizetési határidő': '',
  'Teljesítmény (kW)': '',
  'Profil- szám': '',
  'Fogyasztás kWh': '',

  'Szerződés kezdete': '',
  'Szerződés vége': '',
  'Szerződéses ár': '',

  'Ajánlati ár HUF/kWh-EUR/MWh': '',
  'Valutanem': '',

  'KÁT': '',
  'KÁT szöveg': '',

  // Dinamikus POD táblázat
  'POD_TABLE': '',

  'POD': '',
  'Fogy.hely cím': '',
  'Irányítószám': '',
  'Város': '',
  'Utca, házszám': '',
  'Távmért / Profilos': '',
  'MÉF / Éves mennyiség (kWh)': '',

  'POD 2': '',
  'Fogy.hely cím 2': '',
  'Irányítószám 2': '',
  'Város 2': '',
  'Utca, házszám 2': '',
  'Távmért / Profilos 2': '',
  'MÉF 2 / Éves mennyiség (kWh)': '',

  'POD 3': '',
  'Fogy.hely cím 3': '',
  'Irányítószám 3': '',
  'Város 3': '',
  'Utca, házszám 3': '',
  'Távmért / Profilos 3': '',
  'MÉF 3 / Éves mennyiség (kWh)': '',

  'POD 4': '',
  'Fogy.hely cím 4': '',
  'Irányítószám 4': '',
  'Város 4': '',
  'Utca, házszám 4': '',
  'Távmért / Profilos 4': '',
  'MÉF 4 / Éves mennyiség (kWh)': '',

  'POD 5': '',
  'Fogy.hely cím 5': '',
  'Irányítószám 5': '',
  'Város 5': '',
  'Utca, házszám 5': '',
  'Távmért / Profilos 5': '',
  'MÉF 5 / Éves mennyiség (kWh)': '',

  'POD 6': '',
  'Fogy.hely cím 6': '',
  'Irányítószám 6': '',
  'Város 6': '',
  'Utca, házszám 6': '',
  'Távmért / Profilos 6': '',
  'MÉF 6 / Éves mennyiség (kWh)': '',
  
  'POD 7': '',
  'Fogy.hely cím 7': '',
  'Irányítószám 7': '',
  'Város 7': '',
  'Utca, házszám 7': '',
  'Távmért / Profilos 7': '',
  'MÉF 7 / Éves mennyiség (kWh)': '',

  'POD 8': '',
  'Fogy.hely cím 8': '',
  'Irányítószám 8': '',
  'Város 8': '',
  'Utca, házszám 8': '',
  'Távmért / Profilos 8': '',
  'MÉF 8 / Éves mennyiség (kWh)': '',

  'POD 9': '',
  'Fogy.hely cím 9': '',
  'Irányítószám 9': '',
  'Város 9': '',
  'Utca, házszám 9': '',
  'Távmért / Profilos 9': '',
  'MÉF 9 / Éves mennyiség (kWh)': '',

  'POD 10': '',
  'Fogy.hely cím 10': '',
  'Irányítószám 10': '',
  'Város 10': '',
  'Utca, házszám 10': '',
  'Távmért / Profilos 10': '',
  'MÉF 10 / Éves mennyiség (kWh)': '',

  'POD 11': '',
  'Fogy.hely cím 11': '',
  'Irányítószám 11': '',
  'Város 11': '',
  'Utca, házszám 11': '',
  'Távmért / Profilos 11': '',
  'MÉF 11 / Éves mennyiség (kWh)': '',

  'POD 12': '',
  'Fogy.hely cím 12': '',
  'Irányítószám 12': '',
  'Város 12': '',
  'Utca, házszám 12': '',
  'Távmért / Profilos 12': '',
  'MÉF 12 / Éves mennyiség (kWh)': '',

  'POD 13': '',
  'Fogy.hely cím 13': '',
  'Irányítószám 13': '',
  'Város 13': '',
  'Utca, házszám 13': '',
  'Távmért / Profilos 13': '',
  'MÉF 13 / Éves mennyiség (kWh)': '',

  'POD 14': '',
  'Fogy.hely cím 14': '',
  'Irányítószám 14': '',
  'Város 14': '',
  'Utca, házszám 14': '',
  'Távmért / Profilos 14': '',
  'MÉF 14 / Éves mennyiség (kWh)': '',

  'POD 15': '',
  'Fogy.hely cím 15': '',
  'Irányítószám 15': '',
  'Város 15': '',
  'Utca, házszám 15': '',
  'Távmért / Profilos 15': '',
  'MÉF 15 / Éves mennyiség (kWh)': '',

  'POD 16': '',
  'Fogy.hely cím 16': '',
  'Irányítószám 16': '',
  'Város 16': '',
  'Utca, házszám 16': '',
  'Távmért / Profilos 16': '',
  'MÉF 16 / Éves mennyiség (kWh)': '',

  'POD 17': '',
  'Fogy.hely cím 17': '',
  'Irányítószám 17': '',
  'Város 17': '',
  'Utca, házszám 17': '',
  'Távmért / Profilos 17': '',
  'MÉF 17 / Éves mennyiség (kWh)': '',

  'POD 18': '',
  'Fogy.hely cím 18': '',
  'Irányítószám 18': '',
  'Város 18': '',
  'Utca, házszám 18': '',
  'Távmért / Profilos 18': '',
  'MÉF 18 / Éves mennyiség (kWh)': '',

  'POD 19': '',
  'Fogy.hely cím 19': '',
  'Irányítószám 19': '',
  'Város 19': '',
  'Utca, házszám 19': '',
  'Távmért / Profilos 19': '',
  'MÉF 19 / Éves mennyiség (kWh)': '',

  'POD 20': '',
  'Fogy.hely cím 20': '',
  'Irányítószám 20': '',
  'Város 20': '',
  'Utca, házszám 20': '',
  'Távmért / Profilos 20': '',
  'MÉF 20 / Éves mennyiség (kWh)': ''
};
